<div class="w-100 h-100 d-flex flex-column" [class.screenblur]="spinnerActive">
  <!-- Gallery Section (Left) -->
  <mat-toolbar class="toolbar option-item d-flex gap-3">
    <span class="toolbar-title flex-fill">Image Gallery</span>
    <span class="flex-spacer"></span>
    <mat-form-field appearance="outline" class="search-field mat-no-hint">
      <mat-label>Search</mat-label>
      <input matInput [ngModel]="searchText" (input)="onSearch($event)" placeholder="Filename..." />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <button mat-icon-button color="accent" *ngIf="[appPermissions.uploadMedia,permissionsActions.edit] | builderPermissions" (click)="onUploadClick()">
      <mat-icon>cloud_upload</mat-icon>
    </button>
    <input #fileInput type="file" accept=".jpg,.jpeg,.png,.webp,.heic,.heif" (change)="onFileSelected($event)" hidden />
  </mat-toolbar>

  <div class="d-flex gallery-container gap-3 flex-fill pt-3">
    <div class="grid-container flex-fill overflow-auto mx-2 px-3">
        <div class="row g-2">
          <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-12" *ngFor="let image of filteredImages">
            <mat-card class="h-100 w-100 card-media" [class.selected]="image.selected" (dblclick)="directSelect(image)" (click)="onSelectImage(image)">
              <div class="flex-fill">
                <mat-spinner *ngIf="loadingMap[image.resource_id]" [id]="image.resource_id" [diameter]="20" class="spinner"></mat-spinner>
                          <img mat-card-image [src]="image.resource_url+'?'+image.resource_version" [alt]="image.resource_name"
                  class="grid-image" (load)="onLoad(image.resource_id)">
              </div>
              <mat-card-content class="mt-auto p-2">
                <span class="truncate">{{image.resource_name}}</span>
              </mat-card-content>
            </mat-card>        
          </div>
        </div>

    </div>

    <!-- Details Overlay Panel (Right) -->
    @if(this.currentInstanse === instanceTypes.popUp){
    <ng-container *ngTemplateOutlet="imageDetails; context: { isPopUp: false }"></ng-container>
    }
  </div>


</div>
<div *ngIf="spinnerActive" [class.spinnerCenter]="spinnerActive">
  <mat-spinner diameter="40"></mat-spinner>
</div>


<ng-template #imageDetails let-isPopUp="isPopUp">
  <div *ngIf="selectedImage" class="image-preview" [class.popup-image-preview]="isPopUp" [class.mx-2]="!isPopUp">

    <div class="details-image"
      [style.backgroundImage]="'url(' + selectedImage.resource_url + '?' + selectedImage.resource_version + ')'">

    </div>
    <ul class="image-details">
      <li><span class="label">Name:</span>
        @if(currentInstanse === instanceTypes.popUp)
        { <span [matTooltip]="selectedImage.resource_name.length > 20 ? selectedImage.resource_name : ''"> 
          {{ selectedImage.resource_name | truncate:20  }}
        </span>
        }@else {
          <span>{{ selectedImage.resource_name }}</span>
        }
        </li>
      <li><span class="label">Created:</span><span>{{ selectedImage.created_date | date:'dd-MM-yyyy, h:mm a' }}</span>
      </li>
      <li *ngIf="selectedImage.resource_version > 1"><span class="label">Modified:</span><span>{{
          selectedImage.last_modified_date | date:'dd-MM-yyyy, h:mm a' }}</span></li>
    </ul>
    <div class="footer d-flex justify-content-between gap-1" *ngIf="isPopUp == false">
      <!-- <button mat-stroked-button color="warn" (click)="deleteResourcedialog() " *ngIf="conflicts">Delete</button> -->
      <span class="flex-fill"></span>
      <!-- <button mat-stroked-button color="accent" (click)="onReplaceImage()" *ngIf="conflicts">Replace</button> -->
      <button mat-flat-button color="primary" (click)="onPickImage(this.selectedImage)">Select</button>
    </div>

  </div>
</ng-template>

<ng-template #imageDetailsPopUp let-dialogRef="dialogRef" *ngIf="!spinnerActive">
  <div [class.screenblur]="spinnerActive">
    <h2 mat-dialog-title>Image</h2>
    <mat-dialog-content>
      <ng-container *ngTemplateOutlet="imageDetails; context: { isPopUp: true }"></ng-container>
    </mat-dialog-content>
    <mat-dialog-actions class="d-flex g-sm-3">
      <div class="flex-fill">
        @if([appPermissions.deleteMedia,permissionsActions.edit] | builderPermissions){
          <button mat-button color="warn" *ngIf="conflicts"  (click)="deleteResourcedialog(dialogRef) ">Delete</button>
        }
      </div>
      <button mat-button color="accent" (click)="dialogRef.close({proceed:true});">Close</button>
      @if([appPermissions.editMedia,permissionsActions.edit] | builderPermissions){
        <button mat-button color="primary" *ngIf="conflicts" (click)="onReplaceImage(dialogRef)">Replace</button>
      }
    </mat-dialog-actions>
  </div>
  <div *ngIf="spinnerActive" [class.spinnerCenter]="spinnerActive">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

</ng-template>

<!-- DELETE CONFIRMATION POPUP -->
<ng-template #deleteDialog let-dialogRef="dialogRef">
  <h2 mat-dialog-title>Delete Confirmation</h2>
  <mat-dialog-content>
    <p>Are you sure you want to delete this item?</p>
  </mat-dialog-content>
  <mat-dialog-actions class="d-flex">
    <button mat-button (click)="dialogRef.close({proceed:false,force:false})">Cancel</button>
    <span class="flex-fill"></span>
    <button mat-button color="warn" (click)="dialogRef.close({proceed:true,force:false});">Proceed</button>
  </mat-dialog-actions>
</ng-template>

<!-- REPLACE CONFIRMATION POPUP -->
<ng-template #replaceDialog let-dialogRef="dialogRef">
  <h2 mat-dialog-title>Replace Confirmation</h2>
  <mat-dialog-content>
    <p>Are you sure you want to replace this item?</p>
  </mat-dialog-content>
  <mat-dialog-actions class="d-flex">
    <button mat-button (click)="dialogRef.close({proceed:false,force:false})">Cancel</button>
    <span class="flex-fill"></span>
    <button mat-button color="primary" (click)="dialogRef.close({proceed:true,force:false}); ">Proceed</button>
  </mat-dialog-actions>
</ng-template>


<!-- Relace force conformation popup  -->
<ng-template #forceConformation let-data="data" let-dialogRef="dialogRef">
  <div mat-dialog-title>Replace confirmation</div>
  <mat-dialog-content>
    <div class="dialog-content">
      @if(conflicts?.pages.length){
      <div [innerHTML]="formattedReplaceMessage"></div>
      }
      <div *ngIf="conflicts?.applicationName">
        {{ conflicts.pages.length > 0 ? 'Also used' : 'Used' }}
        as the logo for {{ conflicts.applicationName }} application
      </div>
      <div> Are you sure you want to proceed?</div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="d-flex">
    <button mat-button (click)="dialogRef.close({proceed:false,force:false});">Cancel</button>
    <span class="flex-fill"></span>
    <button mat-button color="primary" (click)="dialogRef.close({proceed:true,force:true});">Proceed</button>
  </mat-dialog-actions>
</ng-template>


<!-- delete force conformation popup  -->
<ng-template #deleteForceConformation let-data="data" let-dialogRef="dialogRef">
  <div mat-dialog-title>Delete confirmation</div>
  <mat-dialog-content>
    <div class="dialog-content">
      @if(conflicts?.pages.length){
      <div [innerHTML]="formattedMessage"></div>
      }
      <div *ngIf="conflicts?.applicationName">
        {{ conflicts.pages.length > 0 ? 'Also used' : 'Used' }}
        as the logo for {{ conflicts.applicationName }} application
      </div>
      <div> Are you sure you want to proceed?</div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="d-flex">
    <button mat-button (click)="dialogRef.close({proceed:false,force:false});">Cancel</button>
    <span class="flex-fill"></span>
    <button mat-button color="warn" (click)="dialogRef.close({proceed:true,force:true});">Proceed</button>
  </mat-dialog-actions>
</ng-template>